import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# 🧩 Scripts

HawkClient supports powerful scripting capabilities that allow you to write custom logic at different levels:

- **Pre-request scripts** – Modify requests before they are sent
- **Post-response scripts** – Validate and manipulate responses
- **Collection-level scripts** – Apply shared logic across multiple requests

You can import Node.js modules, use environment variables, and integrate with third-party libraries such as \`faker\` to generate dynamic test data.

Scripts give you fine-grained control over the entire API testing workflow.

---

## 📸 Examples

![Script Overview](/scripts/ScriptOverview.png)

![Script Tests](/scripts/ScriptTest.png)
`;

const ScriptOverview = () => {
    return (
        <MarkDownRenderer
            title="Scripts"
            markDownText={markdownContent}
        />
    );
};

export default ScriptOverview;
